module.exports = __webpack_public_path__ + "media/06extraordinary.419f1477.mp3";